export enum ECurrency {
  USD = 'USD',
  MXN = 'MXN',
  PEN = 'PEN',
  COP = 'COP',
  CRC = 'CRC',
  DOP = 'DOP',
  GTQ = 'GTQ',
}

export enum PaymentMethod {
  CARD = 'CARD',
  BILLING_CARD = 'BILLING_CARD',
  BILLING_TRANSFER = 'BILLING_TRANSFER',
  CASH = 'CASH',
  ACTIVATION_CODE = 'ACTIVATION_CODE',
  TERMINAL = 'TERMINAL'
}
